import React, { useState, useEffect } from 'react';
import { Form } from 'react-final-form';
import { useHistory, useParams } from 'react-router-dom';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import { Card, CardBody } from '@spark/ui-components/components/Card';
import { FormButtonToolbar, FormContainer } from '@spark/ui-components/components/form/FormElements';
import { formStructure, formSections, validateForm, initialValues } from './formConfig';
import DynamicForm from '@spark/ui-components/components/form/DynamicForm';
import { notification } from '@spark/ui-components/utils/notification';
import {
  createMotorista,
  updateMotorista,
  getMotoristaById,
} from '@spark/services';

const Forms = ({ isReadOnly = false, hideHeader = false }) => {
  const history = useHistory();
  const { id } = useParams();
  const isEditMode = Boolean(id);

  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(isEditMode);
  const [motorista, setMotorista] = useState(initialValues);

  useEffect(() => {
    if (isEditMode) {
      loadMotorista();
    }
  }, [id, isEditMode]);

  const loadMotorista = async () => {
    try {
      setLoadingData(true);
      const response = await getMotoristaById(id);
      const responseData = response?.data || response;

      if (responseData) {
        setMotorista({
          Nome: responseData.Nome || '',
          Cpf: responseData.Cpf || '',
          CodigoIntegracao: responseData.CodigoIntegracao || '',
          Tipo: responseData.Tipo || 'Terceiro',
          Ativo: responseData.Ativo === 1 || responseData.Ativo === true,
        });
      }
    } catch (err) {
      console.error('Erro ao carregar motorista:', err);
      notification.error(
        err?.message || 'Erro ao carregar motorista',
        'Erro ao carregar'
      );
      history.push('/pages/motoristas');
    } finally {
      setLoadingData(false);
    }
  };

  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      // Garantir que Tipo seja sempre uma string
      let tipoValue = values.Tipo;
      if (tipoValue && typeof tipoValue === 'object' && tipoValue.value) {
        tipoValue = tipoValue.value;
      }
      if (!tipoValue || tipoValue === '') {
        tipoValue = 'Terceiro';
      }

      const dados = {
        Nome: values.Nome,
        Cpf: values.Cpf.replace(/\D/g, ''),
        CodigoIntegracao: values.CodigoIntegracao || null,
        Tipo: tipoValue,
        Ativo: values.Ativo ? 1 : 0,
      };

      if (isEditMode) {
        await updateMotorista(id, dados);
        notification.success('Motorista atualizado com sucesso');
      } else {
        await createMotorista(dados);
        notification.success('Motorista cadastrado com sucesso');
      }

      history.push('/pages/motoristas');
    } catch (err) {
      console.error('Erro ao salvar motorista:', err);
      notification.error(
        err?.message || 'Erro ao salvar motorista',
        'Erro ao salvar'
      );
    } finally {
      setLoading(false);
    }
  };

  if (loadingData) {
    return (
      <Card>
        <CardBody>
          <p>Carregando dados do motorista...</p>
        </CardBody>
      </Card>
    );
  }

  return (
    <Card>
      <CardBody>
        {!hideHeader && (
          <h4 style={{ marginBottom: '20px', fontWeight: 600 }}>
            {isEditMode ? 'Editar Motorista' : 'Novo Motorista'}
          </h4>
        )}

        <Form
          onSubmit={handleSubmit}
          initialValues={motorista}
          validate={validateForm}
          render={({ handleSubmit: handleFormSubmit, submitting }) => (
            <FormContainer onSubmit={handleFormSubmit}>
              <DynamicForm
                structure={formStructure}
                sections={formSections(motorista)}
                isViewMode={isReadOnly}
              />

              {!isReadOnly && (
                <FormButtonToolbar>
                  <ButtonWithLoading
                    variant="primary"
                    type="submit"
                    loading={loading || submitting}
                    disabled={loading || submitting}
                  >
                    {isEditMode ? 'Salvar Alterações' : 'Cadastrar Motorista'}
                  </ButtonWithLoading>
                </FormButtonToolbar>
              )}
            </FormContainer>
          )}
        />
      </CardBody>
    </Card>
  );
};

export default Forms;
